import React, { useEffect, useRef, useState } from 'react';
import { ConnectInfoDto } from '../models/connect-info-dto';
import httpService from '../api/HttpService';
import PlayerWindow from './player-window';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { usePlayer } from '../context/PlayerContext';
import { Alert } from 'react-bootstrap';

const ConnectToTable: React.FC = () => {
    // Get url parameters id and p
    const urlParams = new URLSearchParams(window.location.search);
    const licenseId = urlParams.get('id');
    const playerNumber = urlParams.get('p');

    const [connectInfo, setConnectInfo] = useState<ConnectInfoDto>();
    const [signalRId, setSignalRId] = useState('');

    const [joined, setJoined] = useState(false);
    const [joinErrorMessage, setJoinErrorMessage] = useState<string>();

    // Only create the connection once
    const hubConnectionRef = useRef<HubConnection>();

    const { player, setPlayer } = usePlayer();

    useEffect(() => {
        if (!hubConnectionRef.current) {
            const connection = new HubConnectionBuilder()
                .withUrl(httpService.BaseUrl + "connectHub", { withCredentials: false })
                .withAutomaticReconnect()
                .build();

            connection.on("connected", (id: string) => {
                console.log("SignalR", id);
                setSignalRId(id)
            });
            connection.on("joinInProgress", () => {
                setJoined(true);
                setTimeout(() => setJoined(false), 60000);
            });
            connection.on("joinFailed", (message: string) => {
                setJoinErrorMessage(message);
                setTimeout(() => setJoinErrorMessage(undefined), 10000);
            });
            connection.start();
            hubConnectionRef.current = connection;
        }

        return () => {
            hubConnectionRef.current?.stop();
        };
    }, []);

    useEffect(() => {
        if (!licenseId || !playerNumber) {
            console.error('Missing required parameters: id or p');
            return;
        }

        const fetchConnectInfo = async () => {
            const response = await httpService.get<ConnectInfoDto>(`api/connect/${licenseId}`);
            setConnectInfo(response);
        };

        fetchConnectInfo();

    }, [licenseId, playerNumber]);

    const joinClick = async () => {
        const hubConnection = hubConnectionRef.current;
        if (hubConnection && hubConnection.state === "Disconnected") {
            await hubConnection.start();
        }
        if (signalRId && licenseId && player && playerNumber) {
            hubConnection?.invoke("playerJoin", licenseId, player.id, parseInt(playerNumber));
        }
    }

    return (
        <div>
            <div className='connect-container'>

                <div>
                    <div className="header">
                        <h1>Connect to Table</h1>
                    </div>
                    {connectInfo &&
                        <div className='d-flex'>
                            <div className="content mr-auto">
                                <h2>{connectInfo.tableName}</h2>
                                <h3>{connectInfo.organizationName}</h3>
                            </div>
                            <img
                                src="/logo192.png" // TODO: Use club logo 
                                width='80px'
                                height='80px'
                            />
                        </div>
                    }
                </div>
                <PlayerWindow redirectUrl={window.location.href}></PlayerWindow>
                {connectInfo &&
                    <div className='d-grid gap-2'>
                        {player ?
                            <p className='connect-text'>By clicking on Connect you will join {connectInfo.tableName} at {connectInfo.organizationName} as player {playerNumber}</p>
                            :
                            <p>You need to find your player profile above before you can join the table.</p>
                        }
                        {joined &&
                            <Alert variant='success'><strong>Joined succesfully!</strong></Alert>
                        }
                        {joinErrorMessage && !joined &&
                            <Alert variant='danger'><strong>{joinErrorMessage}</strong></Alert>
                        }
                        {!joined &&
                            <button
                                disabled={!player}
                                type="button"
                                className="btn btn-lg btn-primary w-100"
                                onClick={joinClick}
                            >
                                Connect
                            </button>
                        }
                    </div>
                }
            </div>
        </div>
    );
};

export default ConnectToTable;